export enum FunctionType {
  DIAGNOSIS = 1,
  PAGE_ANALYSIS,
  CHART_SQL,
  INDUSTRY_INDICATORS,
}


export const FunctionTypeMap = {
  [FunctionType.DIAGNOSIS]: '诊断',
  [FunctionType.PAGE_ANALYSIS]: '页面分析',
  [FunctionType.CHART_SQL]: '图表SQL',
  [FunctionType.INDUSTRY_INDICATORS]: '行业指标',
};

export enum Role {
  USER = 'user',
  ASSISTANT = 'assistant',
}
